export default{
    ai__area_item_id:"ID VoceArea",
    ai__area_id:"ID Area",
    ai__municipality_id:"ID Comune",
    ar__area_id:"ID Area",
    ar__name:"Nome",
    ar__created_at: "Area creata il",
    ar__updated_at: "Area aggiornata il",
    ar__active: "Area attiva",
    ar__deactived_at: "Area disattivata il",
    cu__customer_id:"ID cliente",
    cu__user_id:"ID Agemte",
    cu__fatt_api_id:"ID",
    cu__fatt_api_name: "Nome Cliente",
    cu__fatt_api_vat_number:"Partita IVA",
    cu__fatt_api_type: "Tipologia",
    cu__fatt_api_tax_code: "Codice Fiscale",
    cu__fatt_api_address_street:"Via",
    cu__fatt_api_postal_code:"CAP",
    cu__fatt_api_city:"Città",
    cu__fatt_api_address_province:"Provincia",
    cu__fatt_api_country:"Paese",
    cu__fatt_api_email:"Email",
    cu__fatt_api_certified_email:"PEC",
    cu__fatt_api_phone:"Numero di telefono",
    cu__fatt_api_ei_code:"Codice Sdi",
    cu__fatt_created_at:"Cliente creato il",
    cu__fatt_updated_at:"Cliente aggiornato il",
    uc__user_customer_id: "ID associazione",
    uc__user_id: "Agente Assegnato",
    uc__customer_id: "Cliente Assegnato",
    uc__start_date: "Data inizio Associazione",
    uc__end_date: "Data fine Associazione",
    ga__id:"ID",
    ga__description:"Descrizione",
    hd__historical_discount_id:"Historical Discount Id",
    hd__user_product_id:"ID Prodotto Utente",
    hd__discount:"Sconto",
    hd__created_at:"Prodotto creato il",
    hp__historical_provision_id:"Historical Provision Id",
    hp__user_products_id:"User Products Id",
    hp__provision:"Provvigione",
    hp__created_at:"Creato il",
    mu__municipality_id:"ID Comune",
    mu__region_id:"ID Regione",
    mu__province_id:"Province Id",
    mu__name:"Nome",
    mu__province_capital:"Capoluogo di Provincia",
    mu__cadastral_code:"Codice Catastale",
    mu__latitude:"Latitudine",
    mu__longitude:"Longitudine",
    ot__order_transiction_id:"Order Transiction Id",
    ot__order_id:"ID Ordine",
    ot__user_product_id:"ID Prodotto Utente",
    ot__fatt_api_qty:"Quantità",
    ot__fatt_api_net_price:"Prezzo Netto",
    ot__fatt_api_gross_price:"Prezzo Lordo",
    ot__fatt_api_stock:"Stock",
    ot__fatt_api_discount:"Sconto",
    ot__transiction_provision_perc:"Percentuale Provvigione Transazione",
    ot__transiction_provision_value:"Valore Provvigione Transazione",
    ot__created_at:"Transizione creata il",
    ot__updated_at:"Transizione aggiornata il",
    or__order_id:"ID Ordine",
    or__fatt_api_order_id:"Id Ordine",
    or__user_id:"ID Utente",
    or__customer_id:"ID Cliente",
    or__installer_id:"ID Installatore",
    or__created_at:"Ordine creato il",
    or__updated_at:"Ordine aggiornato il",
    or__fatt_api_notes:"Note",
    or__fatt_api_date:"Data Ordine",
    pe__permission_id:"ID Permesso",
    pe__permission_key:"Chiave Permesso",
    pr__product_id:"ID Prodotto",
    pr__fatt_api_id:"ID",
    pr__fatt_api_code:"Codice",
    pr__fatt_api_category:"Categoria",
    pr__fatt_api_net_price:"Prezzo Netto",
    pr__fatt_api_gross_price:"Prezzo Lordo",
    pr__fatt_api_name:"Nome",
    pr__fatt_api_description:"Descrizione",
    pr__fatt_api_in_stock:"Disponibile",
    pr__fatt_api_stock_current:"Scorta Attuale",
    pr__fatt_api_created_at:"Prodotto Creato il",
    pr__fatt_api_updated_at:"Prodotto Aggiornato il",
    pr__fatt_api_notes:"Note",
    pr__product_type: "Tipologia Prodotto",
    pr__discount: "Sconto Massimo di base",
    pr__provision: "Provvigione di base",
    user_products_assign: "Prodotti Assegnati",
    pv__province_id:"Province Id",
    pv__region_id:"ID Regione",
    pv__metropolitan_city_code:"Codice Città Metropolitana",
    pv__name:"Nome",
    pv__car_abbreviation:"sigla",
    pv__latitude:"Latitudine",
    pv__longitude:"Longitudine",
    ps__provision_scheme_id:"ID Schema Provvigione",
    ps__provision_scheme_code:"Codice Schema Provvigione",
    ps__start_range:"Intervallo Iniziale",
    ps__end_range:"Intervallo Finale",
    ps__discount:"Sconto",
    ps__provision:"Provvigione",
    ps__created_at:"Creato il ",
    ps__updated_at:"Aggiornato il ",
    re__region_id:"ID Regione",
    re__name:"Nome",
    re__latitude:"Latitudine",
    re__longitude:"Longitudine",
    re__geographical_area_id:"Geographical Area Id",
    ua__user_areas_id:"ID Aree Utente",
    ua__user_id:"ID Utente",
    ua__area_id:"ID Area",
    ua__associated_at:"Associato il",
    ua__disassociated_at:"Disassociato il",
    up__user_permission_id:"ID Permesso Utente",
    up__user_type_id:"ID Tipo Utente",
    up__permission_id:"ID Permesso",
    up__update:"Aggiorna",
    up__add:"Aggiungi",
    up__delete:"Elimina",
    uo__user_products_id:"User Products Id",
    uo__user_id:"ID Utente",
    uo__user_ids:"Agenti da associare",
    uo__product_id:"ID Prodotto",
    uo__provision:"Provvigione",
    uo__discount:"Sconto",
    uo__provision_scheme_code:"Codice Schema Provvigione",
    uo__created_at:"Creato il",
    uo__updated_at:"Aggiornato il",
    ut__user_type_id:"ID Tipo Utente",
    ut__description:"Permesso",
    ut__description_key:"Chiave Permesso",
    us__user_id:"ID Utente",
    us__name:"Nome",
    us__last_name:"Cognome",
    us__email:"Email",
    us__password:"Password",
    us__user_type_id:"ID Tipo Utente",
    us__created_at:"Creato il",
    us__updated_at:"Aggiornato il",
    us__p_iva:"Partita IVA",
    us__master_id:"ID Master",
    us__active:"Attivo",
    regions_ids: "Regioni",
    provinces_ids: "Province",
    municipality_ids: "Comuni",
    groupConcat_uo__user_id_Count: "Numero utenti",
}